module.exports = __webpack_public_path__ + "static/media/recycle-bin.877794c6.svg";